import React from 'react'
import Select from './select'
import NumberFormat from 'react-number-format'

export const render_field = field => {
  const { meta: { touched, error } } = field;
  const className = `form-group ${touched && error ? 'red-text' : ''}`

  return (
    <div className={className} style={{ flex: 1, height: 70 }}>
      <label>{field.label}</label>
      {
        field.type === 'select' ?
          <Select borderColor={touched && error ? '#F00' : null} options={field.options} onChange={field.input.onChange} defaultValue={field.defaultValue} value={field.value} />
          :
          <div>
            <input
              style={touched && error ? { borderColor: '#F00' } : {}}
              id={field.id}
              type={field.type}
              placeholder={field.placeholder}
              onChange={field.onChange}
              {...field.input}
              // value={field.defaultValue}
            />
          </div>
      }
      <p style={{ color: 'red', fontWeight: 'bold', fontSize: 13, marginTop: 2 }}>{touched && error ? error : ''}</p>
    </div>
  );
}

export const render_phone_field = field => {
  const { meta: { touched, error } } = field;
  const className = `form-group ${touched && error ? 'red-text' : ''}`

  return (
    <div className={className} style={{ flex: 1, height: 70 }}>

      <label>{field.label}</label>
      {
        <div>
          <NumberFormat
            style={touched && error ? { borderColor: '#F00' } : {}}
            id={field.id}
            type={field.type}
            placeholder={field.placeholder}
            format="+# (###) ###-####"
            mask="_"
            onValueChange={field.onChange}
            {...field.input}
            value={field.defaultValue}
          />
        </div>
      }
      <p style={{ color: 'red', fontWeight: 'bold', fontSize: 13, marginTop: 2 }}>{touched && error ? error : ''}</p>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/utils/renderField.js